// Developer images
import het from '../../../assets/developers/hetkikani.jpg';
import pratham from '../../../assets/developers/pratham.jpeg';
import dev from '../../../assets/developers/dev.png';
import vishal from '../../../assets/developers/vishal.jpg';
import satyapalsinh from '../../../assets/developers/satyapalsinh.jpg';

export const developers = [
  {
    id: 1,
    name: 'Het Kikani',
    role: 'MERN Stack Developer',
    empCode: '50689',
    avatar: het,
    quote: 'My methods can be wrong, not the results!!',
  },
  {
    id: 3,
    name: 'Pratham Shah',
    role: 'MERN Stack Developer',
    empCode: '600387',
    avatar: pratham,
    quote: 'Quality is never an accident.',
  },
  {
    id: 2,
    name: 'Dev Mankad',
    role: 'MERN Stack Developer',
    empCode: '50678',
    avatar: dev,
    quote: 'Make you',
  },
  {
    id: 4,
    name: 'Vishal Gohil',
    role: 'MERN Stack Developer',
    empCode: '50723',
    avatar: vishal,
    quote: 'Success is not final; Failure is not fatal; It is the courage to continue that counts!',
  },
  {
    id: 5,
    name: 'Satyapalsinh',
    role: 'MERN Stack Developer',
    empCode: '50712',
    avatar: satyapalsinh,
    quote: "Leadership is not a position, it's an action.",
  },
];
